import AbstractAction from "../AbstractAction";

export default class ChangeStrokeWidthAction extends AbstractAction {
    constructor(provider, appearance, value) {
        super(provider);

        this.appearance = appearance;
        this.oldValue = appearance.strokeWidth;
        this.newValue = value;
    }

    update(value) {
        this.newValue = value;
        this.appearance.strokeWidth = this.newValue;
        this.appearance.parent.row.updateImg();
    }

    finish() {
        this.appearance.strokeWidth = this.newValue;
        this.appearance.parent.row.updateImg();
        this.newValue == this.oldValue
            ? super.discard()
            : super.finish();
    }

    undo() {
        this.appearance.strokeWidth = this.oldValue;
        this.appearance.parent.row.updateImg();
    }

    redo() {
        this.appearance.strokeWidth = this.newValue;
        this.appearance.parent.row.updateImg();
    }
}
